import {useNavigate} from "react-router-dom"; 
const LittleNavigation = ({section, name, destination })=>{
    const navigate = useNavigate(); 
    function handleClick(){
        navigate(`/${destination}`); 
    }
    return (
        <>
            <div className = 'grid grid-cols-1'>
                <div>
                    <h2 className = "text-white text-3xl font-bold">{section} </h2>
                    <p className = "text-white text-2xl">{name}</p>
                </div>
                <p className = "text-white text-2xl" onClick = {handleClick}> __{destination}</p>
            </div>
        </>
    ); 
}
export default LittleNavigation; 
